// Public routes
const loginRoute = '/login';
const logoutRoute = '/logout';
const inCompleteConfigurationRoute = '/incompleteConfiguration';
const supportLoginRoute = '/support/login';

// Header routes
const accessViewRoute = '/accessView';
const myAccountRoute = '/myAccount';
const alertsCenterRoute = '/alerts-center';
const viewMessagesRoute = '/viewMessages';

// Work Queue routes
const workQueueRoute = '/workQueue';
const unassignedPatientRoute = '/unassignedPatient/:associationQueueId';

// Patient Routes
const patientRoute = '/patient/:patientId';
const editPatientRoute = '/editPatient/:patientId';
const addPatientRoute = '/addPatient';
const clinicalSummaryRoute = '/clinicalSummary';
const editPatientBranchRoute = '/editPatientBranch';

// Assessment routes
const activityRoute = '/patient/:patientId/activity/:activityId';
const assessmentPreviewRoute = '/assessment/:assessmentId/preview';
const contentMonographRoute = '/content-monograph/:label';

// Referral routes
const referralBaseRoute = '/patient/:patientId/referral';
const referralManagerRoute = `${referralBaseRoute}-manager`;
const referralDetailRoute = `${referralBaseRoute}/:referralId`;
const referralBenefitsInvestigationRoute = `${referralDetailRoute}/benefits-investigation/:benefitsInvestigationId/type/:typeId`;
const referralPriorAuthorizationRoute = `${referralDetailRoute}/prior-authorization/:priorAuthorizationId/type/:typeId`;
const referralFinancialAssistanceRoute = `${referralDetailRoute}/financial-assistance/:financialAssistanceId/type/:typeId`;
const referralAppealRoute = `${referralDetailRoute}/appeal/:activityId/type/:typeId`;

// Find Patient routes
const findPatientRoute = '/findPatient';
const pdxFindPatientRoute = '/pdxFindPatient';

// Reporting routes
const advancedReportsRoute = '/advancedReports';
const therigyInsightsRoute = '/reportEngine';

// Tools routes
const addEditMedicationRoute = '/add-edit-medication';
const addMedicationRoute = '/add-medication';
const editMedicationRoute = '/edit-medication';

const alertsManagerRoute = '/alerts-manager';

const assessmentManagerHomeRoute = '/assessment-manager/:categoryId?';
const assessmentManagerCreateRoute = `${assessmentManagerHomeRoute}/create`;
const assessmentManagerEditRoute = `${assessmentManagerHomeRoute}/edit/:assessmentId`;
const assessmentManagerCloneRoute = `${assessmentManagerHomeRoute}/clone/:assessmentId`;
const assessmentManagerQuestionsRoute = `${assessmentManagerHomeRoute}/questions/:assessmentId`;
const assessmentManagerChildQuestionsRoute = `${assessmentManagerQuestionsRoute}/parent-question/:parentQuestionId/parent-answer/:parentAnswerId`;

const assessmentPublisherRoute = '/assessment-publisher';

const contentLibraryRoute = '/content-library';
const contentLibraryEditRoute = `${contentLibraryRoute}/content-group/:groupUuid`;

const contentPublisherRoute = '/content-publisher';

const therapeuticCategoriesRoute = '/therapeutic-categories';
const therapeuticCategoriesCreateRoute = `${therapeuticCategoriesRoute}/create`;
const therapeuticCategoriesEditRoute = `${therapeuticCategoriesRoute}/:therapyId`;

const questionGroupsRoute = '/question-groups';

const assignmentManagerRoute = '/assignment-manager';

const medicationManagementRoute = '/medicationManagement';

const patientMessagingRoute = '/patientmessaging';

const protocolManagerRoute = '/protocolManager';
const protocolManagerCreateRoute = `${protocolManagerRoute}/protocol`;
const protocolManagerEditRoute = `${protocolManagerRoute}/protocol/:protocolId`;

const protocolPublisherRoute = '/protocolPublisher';

const protocolTemplateBuilderRoute = '/protocol-template-builder';

const queueManagerRoute = '/queue-manager';

const userManagerRoute = '/user-manager';
const createUserRoute = '/user/new';
const enableUserRoute = '/user/:userId/enable';
const viewDisabledUserRoute = '/user/:userId/disabled';
const viewEditUserRoute = '/user/:userId';

const patientUploadRoute = '/patientUpload';
const physicianUploadRoute = '/physicianUpload';

const ssoConfigurationRoute = '/ssoConfiguration';

export {
    accessViewRoute,
    activityRoute,
    addEditMedicationRoute,
    addMedicationRoute,
    addPatientRoute,
    alertsCenterRoute,
    alertsManagerRoute,
    advancedReportsRoute,
    assessmentManagerChildQuestionsRoute,
    assessmentManagerCloneRoute,
    assessmentManagerCreateRoute,
    assessmentManagerEditRoute,
    assessmentManagerHomeRoute,
    assessmentManagerQuestionsRoute,
    assessmentPreviewRoute,
    assessmentPublisherRoute,
    assignmentManagerRoute,
    clinicalSummaryRoute,
    contentLibraryEditRoute,
    contentLibraryRoute,
    contentMonographRoute,
    contentPublisherRoute,
    createUserRoute,
    editMedicationRoute,
    editPatientBranchRoute,
    editPatientRoute,
    enableUserRoute,
    findPatientRoute,
    inCompleteConfigurationRoute,
    loginRoute,
    logoutRoute,
    medicationManagementRoute,
    myAccountRoute,
    patientMessagingRoute,
    patientRoute,
    patientUploadRoute,
    pdxFindPatientRoute,
    physicianUploadRoute,
    protocolManagerCreateRoute,
    protocolManagerEditRoute,
    protocolManagerRoute,
    protocolPublisherRoute,
    protocolTemplateBuilderRoute,
    questionGroupsRoute,
    queueManagerRoute,
    referralAppealRoute,
    referralBenefitsInvestigationRoute,
    referralDetailRoute,
    referralFinancialAssistanceRoute,
    referralManagerRoute,
    referralPriorAuthorizationRoute,
    ssoConfigurationRoute,
    supportLoginRoute,
    therapeuticCategoriesCreateRoute,
    therapeuticCategoriesEditRoute,
    therapeuticCategoriesRoute,
    therigyInsightsRoute,
    unassignedPatientRoute,
    userManagerRoute,
    viewDisabledUserRoute,
    viewEditUserRoute,
    viewMessagesRoute,
    workQueueRoute,
};
